var map = {
	"./amigo-clinic.svg": 5669,
	"./amigo-default.svg": 1790,
	"./amigo-logo.svg": 2508,
	"./amigo-name-logo.svg": 1571,
	"./amigo-one-white.svg": 3383,
	"./amigo.svg": 6161,
	"./avatar.svg": 3048,
	"./download-button.svg": 6866,
	"./expired-link-warning-icon.svg": 308,
	"./pen-field.svg": 3478,
	"./signbox.svg": 8757,
	"./success-pure.svg": 2649,
	"./text.svg": 2694,
	"./trash.svg": 1149,
	"./undo.svg": 4808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;